import { Box, Button, IconButton, Divider } from '@mui/material'
// import EditOutlienedIcon from '@mui/icons-material/EditOutlined'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'

const TestCaseActions = ({
  testCase,
  handleOpenRegenerateDialog,
  handleOpenDeleteDialog,
  handleRunTestCase,
  handleGenerateNegative
}) => {
  const normalizedStatus = String(testCase?.status || '').toUpperCase();
  const isDraft = normalizedStatus === 'DRAFT';
  const isQueuedOrRunning =
    normalizedStatus === 'RUNNING' || normalizedStatus === 'PENDING';

  return (
    <Box className="testCaseActions">
      { testCase?.isActive ?
        <>
          <Box className="testCaseActionsButtons">
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleOpenRegenerateDialog}
              disabled={isQueuedOrRunning}
            >
              Regenerate test
            </Button>

            {testCase.status === 'INITIAL_FAILURE' && (
              <Button
                variant="outlined"
                color="warning"
                sx={{ ml: 1 }}
                onClick={handleGenerateNegative}
                disabled={
                  isQueuedOrRunning ||
                  !testCase.is_positive
                }
              >
                Generate negative
              </Button>
            )}

            <Button
              variant="contained"
              color="secondary"
              sx={{ ml: 1 }}
              onClick={handleRunTestCase}
              disabled={isQueuedOrRunning}
            >
              {isDraft ? 'Approve and Run' : 'Re-run'}
            </Button>
          </Box>
          <Divider orientation="vertical" flexItem/>
          {/* <IconButton className="testCaseActionsEditIconButton" onClick={handleOpenEditDialog}>
            <EditOutlinedIcon color='secondary' />
          </IconButton> */}
          <IconButton className="testCaseActionsDeleteIconButton" onClick={handleOpenDeleteDialog}>
            <DeleteOutlineOutlinedIcon color='error' />
          </IconButton>
        </> : null
      }
    </Box>
  )
}

export default TestCaseActions
